// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "HomeBranding" + "." + "865a2cce" + ".css";
};